import React, { useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import TEXTS from '../controller/TextVariables';

export default function Legend() {
    const { theme, scope } = useContext(InterfaceContext);
    const { legend } = TEXTS;
    return (
        <section id="map-legend" aria-label="Interactive Map Legend">
            <div className="Legend-container">
                <label title={legend.tooltip}>{legend.label}</label>
                <ul className="legend-bars">
                    <li
                        title={legend.low.tooltip}
                        className="leg-bar low"
                        style={{
                            background: theme.colorPallet.low
                        }}
                    >
                        {legend.low.label}
                    </li>
                    <li
                        title={legend.med.tooltip}
                        className="leg-bar med"
                        style={{
                            background: theme.colorPallet.med
                        }}
                    >
                        {legend.med.label}
                    </li>
                    <li
                        title={legend.high.tooltip}
                        className="leg-bar high"
                        style={{
                            background: theme.colorPallet.high
                        }}
                    >
                        {legend.high.label}
                    </li>
                    <li
                        title={legend.top.tooltip}
                        className="leg-bar top"
                        style={{
                            background: theme.colorPallet.top
                        }}
                    >
                        {legend.top.label}
                    </li>
                    <li title={legend.none.tooltip} className="leg-bar none">
                        <span> {legend.none.label} </span>
                    </li>
                    <li className="fix  layout"></li>
                    {scope === 'state' && (
                        <li title={legend.non_applicable.tooltip} className="leg-bar n-a">
                            {legend.non_applicable.label}
                        </li>
                    )}
                </ul>
            </div>
        </section>
    );
}
